export class ReasonController {

    /* @ngInject */
    constructor(flowStateService, flowService, $stateParams) {
        this.flowStateService = flowStateService;
        this.flowService = flowService;
        this.$stateParams = $stateParams;
    }

    handleSubmit() {
        this.flowStateService.setLoginReason(this.loginReason);
        this.flowService.nextFlow();
    }
}
